import React, { useContext } from 'react';
import Share from '../Share';
import SaveToFavoritesButton from '../SavedHouses/SaveToFavoritesButton';
import { getPropertyTypeByCode } from 'src/utils/getPropertyTypeByCode';
import {
  UnitPageContext,
  UnitPageContextInterface,
} from '../../pages/[urlParam]/[urlBuildParam]/[urlUnitParam]';
import ErrorBoundary from '../ErrorBoundary';
import { contactListingAddress } from 'src/utils/utils';

interface UnitHeaderProps {
  unitNameRef?: React.RefObject<HTMLHeadingElement | null>;
  includeGA4Id?: boolean;
}

export const UnitHeader: React.FC<UnitHeaderProps> = ({
  unitNameRef,
  includeGA4Id = false,
}) => {
  const { building, listing, favorite, unit, city } = useContext(
    UnitPageContext
  ) as UnitPageContextInterface;

  const { id: unitId } = unit;
  const { propertyTypeCode, unitNumber, id } = listing;
  const { primaryAddress } = building;

  const isMainStreetPartsExist =
    listing?.address?.streetNumber && listing?.address?.streetName;

  const address = isMainStreetPartsExist
    ? contactListingAddress(listing?.address, city.name)
    : primaryAddress;
  const sectionId = includeGA4Id
    ? `${propertyTypeCode === 'R' ? 'for-rent-ga4' : 'for-sale-ga4'}`
    : undefined;

  return (
    <ErrorBoundary>
      <section
        className="container md:mb-[16px] text-m md:pb-[2px] pt-4 md:pt-[20px] lg:pt-2 lg:pb-2 lg:mb-0"
        id={sectionId}
      >
        <div className="relative flex flex-col-reverse justify-between lg:flex-row">
          <div>
            <h1
              ref={unitNameRef}
              className="px-px py-1 pt-[10px] md:pt-0 mb-0 lg:pt-0 text-23-29-0.77 lg:text-24-32-0.3 uppercase font-sohneBreitBuch"
            >
              {building.name} #{unitNumber || unit?.unique}
            </h1>
            <p className="px-px pt-[4px] text-14-21-0.3 md:text-14-26-0.3 md:mb-0 w-[95%] lg:w-[100%]">
              {address}
            </p>
          </div>
          <div className="relative flex pt-px mb-2 space-x-3 text-16-26-0.3 lg:right-0 lg:-top-2 lg:relative">
            <div className="mt-0.5 lg:w-full md:mt-[14px] lg:ml-0 lg:mt-2">
              <SaveToFavoritesButton
                visibility="block"
                userFavorites={favorite}
                unitId={unitId}
                type={getPropertyTypeByCode(propertyTypeCode)}
                full
                iconWidth={15}
                iconHeight={18}
              />
            </div>
            <div className="mt-0.5 lg:w-full md:mt-[14px] lg:mt-2">
              <Share visibility="block" />
            </div>
          </div>
        </div>
      </section>
    </ErrorBoundary>
  );
};
